import withState from 'recompose/withState';

export default withState('chatUnreadMessagesCount', 'setUnreadMessagesCount', 0);
